import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { inject } from "@vercel/analytics";
import { SpeedInsights } from "@vercel/speed-insights/react";
import App from "./App.tsx";
import "./index.css";

// Initialize Vercel Analytics
inject({ debug: true });

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
    <SpeedInsights />
  </HelmetProvider>
);
